<template>
	<div class="input-wrapper">
		<p
			v-if="labelText"
			class="label form-label"
		>
			{{ labelText }}
		</p>
		<select
			id="select"
			v-model="selected"
			class="dropdown"
			:class="{
				'input--error': v$.selected.$dirty && selected === '',
			}"
			:autocomplete="inputAutocomplete ?? undefined"
			@change="$emit('selected', selected)"
			@blur="handleClick"
		>
			<option
				id="placeholder"
				value=""
				disabled
				selected
				v-if="noPleaseSelect == false"
			>
				Please select
			</option>

			<template v-if="hasSplitValueAndText">
				<option v-for="option in options"
					:key="option.value"
					:value="option.value"
					:selected="(selected && selected === option.value.toString() ? 'selected': null)">
					{{ option.text }}
				</option>
			</template>
			<template v-else>
				<option
					v-for="(option, index) in options"
					:key="option"
					:value="option"
					:selected="noPleaseSelect && index == 0 ? selected : null"
				>
					{{ option }}
				</option>
			</template>	
		</select>
		<p
			v-if="v$.selected.$error"
			class="error-text"
		>
			{{ errorTextComputed }}
		</p>
		<p
			v-else-if="supportText"
			class="support-text"
		>
			{{ supportText }}
		</p>
	</div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
	props: {
		options: {
			type: Array,
			default: function () {
				return [];
			},
		},
		labelText: {
			type: String,
			default: '',
		},
		errorText: {
			type: String,
			default: '',
		},
		supportText: {
			type: String,
			default: '',
		},
		manualInputDirtier: {
			type: Boolean,
			default: false,
		},
		prefillInput: {
			type: String,
			default: '',
			required: false,
		},
		noPleaseSelect: {
			type: Boolean,
			default: false,
		},
		inputAutocomplete: {
			type: String,
			default: '',
		}
	},
	emits: ['selected'],
	data() {
		return {
			selected: '',
			placeholder: 'Please select',
			v$: useVuelidate(),

		};
	},
	computed: {
		errorTextComputed() {
			return this.errorText ? this.errorText : 'Please select';
		},
		hasSplitValueAndText() {
			return (this.options && this.options[0]?.value && this.options[0].text ? true : false);
		},
	},
	methods: {
		handleClick() {
			this.v$.selected.$dirty = true;
		},
	},
	validations() {
		return {
			selected: {
				required,
				$autoDirty: true,
			},
		};
	},
	watch: {
		manualInputDirtier(newValue, oldValue) {
			if (newValue) {
				this.v$.selected.$dirty = true;
			}
		},
		prefillInput(newValue, oldValue) {
			this.selected = newValue;
		},
	},
	mounted() {
		if (this.prefillInput) {
			this.selected = this.prefillInput;
		} else if (this.noPleaseSelect) {
			this.selected = this.options[0];
		}
	},
};
</script>

<style scoped lang="scss">
.support-text {
	font-size: 0.9375rem;
	margin-top: 8px;
	color: #41474f;
}

#placeholder {
	color: #a6a8ac;
}
</style>
